export default __webpack_public_path__ + "static/ananas-4e40384e16d4dba5250a97bbed5ab532.png";